<div class="verify-wrapper">
  <div class="verify-card">
    <h2>Validación de Usuario</h2>

    <div *ngIf="loading" class="loading">
      <div class="spinner"></div>
      <p>Validando tu cuenta, por favor espera...</p>
    </div>

    <div *ngIf="!loading">
      <!-- Caso de enlace expirado -->
      <div *ngIf="linkExpired" class="status expired">
        <span class="icon">⏳</span>
        <p>{{ message }}</p>
        <p class="extra">Solicita un nuevo correo de verificación.</p>
      </div>

      <!-- Caso genérico -->
      <div *ngIf="!linkExpired" class="status" [ngClass]="{ 'success': success, 'error': !success }">
        <span class="icon">
          <ng-container *ngIf="success">✔</ng-container>
          <ng-container *ngIf="!success">✖</ng-container>
        </span>
        <p>{{ message }}</p>
      </div>
    </div>
  </div>
</div>